import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import mixins from './util/mixins';
import * as filters from './util/filters';

// Import Bootstrap
// import 'bootstrap'
import '@/assets/bootstrap.scss';

// Import Bootstrap-Vue
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import FontAwesome
//import './assets/fontawesome.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import Axios
import axios from './util/axios';
import VueAxios from 'vue-axios';

// Configure Vue
Vue.config.productionTip = false;

// Register Vue components
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);

// Register FontAwesome
library.add(fas);
library.add(far);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.component('b-pagination', require('../node_modules/bootstrap-vue/src/components/pagination').default);

// // Register filters
Object.keys(filters).forEach(key => {
	Vue.filter(key, (filters as any)[key]);
})

// Register mixins
Vue.mixin(mixins);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
